import React from 'react';
import { Badge, Tooltip } from 'flowbite-react';
import ProgressBar from './ProgressBar';

interface PositionComponentProps {
	process: string;
	count: number | string;
	className?: string;
	badge?: string;
	unseenApplicationsCount?: number;
	positionData?: {
		assessmentPending?: number;
		interviewing?: number;
		rejected?: number;
	};
}

const PositionComponent: React.FC<PositionComponentProps> = ({
	process,
	count,
	badge,
	className,
	positionData,
	unseenApplicationsCount,
}) => {
	return (
		<>
			<div className={'flex flex-col md:max-w-[200px] max-w-[154px] w-full items-start gap-[8px] overflow-auto'}>
				<div className="flex items-center content-center gap-[8px] self-stretch flex-wrap">
					<p className="content-center items-start flex-1 text-[14px]">{process}</p>
				</div>
				<div className="flex w-full flex-col content-center gap-[8px]">
					<div className="flex flex-row gap-[8px] items-center">
						{Number(count) <= 0 ? (
							<p className="font-inter text-[24px] font-[600] leading-[36px]">{'-'}</p>
						) : (
							<p className="flex font-inter text-[24px] font-[600] flex-col content-start items-center rounded-[8px] leading-[36px]">
								{count}
							</p>
						)}
						{unseenApplicationsCount && unseenApplicationsCount > 0 ? (
							<Badge
								className={`w-max mr-2 rounded-[22px] ${
									badge?.split(' ')[1] === 'new'
										? 'bg-[#FFE5FF]'
										: badge?.split(' ')[1] === 'pending'
										  ? 'bg-[#FFFCB2]'
										  : ''
								}`}
								color="warning"
							>
								{unseenApplicationsCount} New
							</Badge>
						) : null}
					</div>
					<div className="w-full max-w-[200px]">{positionData && <ProgressBar {...positionData} />}</div>
				</div>
			</div>
		</>
	);
};

export default PositionComponent;
